import { IconButton, Button, Autocomplete, Chip, TextField, Box } from '@mui/material';
import React, { ReactElement, useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { NamedEntity } from '../../../types/entities/NamedEntity';
import { SchemaWithClient } from '../../../types/SchemaWithClient';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import { SlidingPaneAddNew } from '../../Page/SlidingPaneAddNew';
import { SlidingPaneEdit } from '../../Page/SlidingPaneEdit';
import { guideReservation } from '../../../schema/guideReservation';
import api from '../../../services/api';
import LargePopper from '../assets/LargePopper';
import AddIcon from "@mui/icons-material/Add";

type Props<T extends NamedEntity> = {
  onChange: (value: any) => void;
  schema: any;
  defaultValue: any;
  forcedValue: any;
  disabled: boolean;
  isMissing: boolean;
  mainSchema: any;
  column: any;
  accordingToValue: any;
  allValue: any;
  moreOptions: any;
  refreshMainTableData?: () => any;
};

export const SPCustomSetFieldForGuideReservation = <T extends NamedEntity>({
  onChange,
  defaultValue,
  forcedValue,
  disabled,
  isMissing,
  schema,
  mainSchema,
  column,
  accordingToValue,
  allValue,
  moreOptions,
  refreshMainTableData,
}: Props<T>): ReactElement | null => {
  const [addingEntity, setAddingEntity] = useState<any>(undefined);
  const [loading, setLoading] = useState(false);
  const [selectOptions, setSelectOptions] = useState<any>([]);

  const [currentState, setCurrentState] = useState<any>({
    value: null,
    send: false,
  });

  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({});

  useEffect(() => {
    if (
      typeof defaultValue !== undefined &&
      defaultValue !== null &&
      defaultValue !== undefined
    ) {
      setSelectOptions(defaultValue);
    }
  }, []);

  const fetchSelectOptions = async (
    searchText: string,
    columnName?: string,
    row?: any
  ) => {
    setLoading(true);

    const searchParams = new URLSearchParams({
      searchValue: searchText,
    });

    schema.client.readNames(1, searchParams).then((result: any) => {
      result.unshift({ id: 0, name: '', isButton: true });
      setSelectOptions(result);
      setLoading(false);
    });
  };

  useEffect(() => {
    setCurrentState({
      value: defaultValue,
      send: false,
    });
  }, [defaultValue]);

  useEffect(() => {
    if (currentState.send) {
      onChange(currentState.value);
    }
  }, [currentState]);

  const handleOnChange = async (value: any) => {
    let isReturn = false;
    value.filter((item: any) => {
      if (item?.isButton) {
        isReturn = true;
      }
      return !item?.isButton;
    });

    if (isReturn) {
      setAddingEntity(true);
    } else {
      let selectedGuide: any = undefined;
      value.map((item: any) => {
        if (!item?.guide_id) {
          selectedGuide = item;
        }
      });

      const currentValue = [...value];

      if (selectedGuide) {
        const createdReservation = await api.post('/guide-reservations', {
          guide_id: selectedGuide?.id,
          guide_wage: allValue?.activity?.guide_wage,
          guide_wage_currency_id: allValue?.activity?.guide_wage_currency_id,
        });

        const newValue: any = currentValue.filter((item: any) => {
          return item?.guide_id;
        });

        newValue.push(createdReservation);

        setCurrentState({
          value: newValue,
          send: true,
        });
      } else {
        setCurrentState({
          value: value,
          send: true,
        });
      }
    }
  };

  return (
    <>
      <Autocomplete
        freeSolo
        fullWidth={true}
        size="small"
        onOpen={() => fetchSelectOptions('')}
        loading={loading}
        PopperComponent={LargePopper}
        multiple
        title={''}
        options={selectOptions}
        renderOption={(props: any, option: any) => {
          return (
            <Box
              component="li"
              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {option?.isButton && (
                <Button
                  startIcon={<AddIcon />}
                  size="small"
                  variant="contained"
                  fullWidth
                >
                  Add new
                </Button>
              )}
              {option?.name ? option?.name : '-'}
            </Box>
          );
        }}
        getOptionLabel={(option) => {
          return option?.name ? option?.name : '-';
        }}
        isOptionEqualToValue={(option, value) => {
          return option?.id === value.guide_id;
        }}
        value={currentState.value ? currentState.value : []}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              size="small"
              InputLabelProps={{
                style: {
                  fontSize: 13,
                  paddingTop: 2,
                },
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          );
        }}
        disabled={disabled}
        renderTags={(value, getTagProps, label: any) => {
          return value.map((option, index) => {
            let optionName = option?.guide?.name ? option?.guide?.name : '';
            if (option?.guide_wage) {
              optionName += ` (${option?.guide_wage}${
                option?.guide_wage_currency
                  ? ` ${option?.guide_wage_currency?.name}`
                  : ''
              })`;
            }

            return (
              <Chip
                {...getTagProps({ index })}
                label={optionName}
                key={`chip-item-${index}`}
                id={`chip-item-${index}`}
                sx={{
                  '& .MuiChip-label': {
                    paddingRight: '6px',
                  },
                  height: 'auto',
                  minHeight: '32px',
                  lineHeight: '20px',
                }}
                deleteIcon={
                  <>
                    {!disabled && (
                      <>
                        <IconButton
                          key={`chip-edit-button-${option?.id}-${index}`}
                          id={`chip-edit-button-${option?.id}-${index}`}
                          aria-label="edit"
                          size="small"
                          color={'primary'}
                          onClick={(event: any) => {
                            if (event?.target?.nodeName === 'BUTTON') {
                              return false;
                            }
                            console.log('You clicked the edit button');

                            setOpenedSlidingPane({
                              schema: guideReservation(),
                              row: option,
                            });
                            return true;
                          }}
                          sx={{
                            padding: '0px',
                            '& .MuiSvgIcon-root': {
                              width: '15px',
                              height: '15px',
                            },
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          key={`chip-delete-button-${option?.id}-${index}`}
                          id={`chip-delete-button-${option?.id}-${index}`}
                          aria-label="delete"
                          size="small"
                          color={'error'}
                          sx={{
                            padding: '0px',
                            paddingRight: '8px',
                            '& .MuiSvgIcon-root': {
                              width: '15px',
                              height: '15px',
                            },
                          }}
                          onClick={(event) => {
                            console.log('You clicked the delete button');
                            const newValue = value.filter(
                              (item: any) => item.id !== option.id
                            );
                            handleOnChange(newValue);
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </>
                    )}
                  </>
                }
              />
            );
          });
        }}
        onChange={(event, newValue) => {
          handleOnChange(newValue);
        }}
      />

      {openedSlidingPane?.row?.id && (
        <SlidingPaneEdit
          schema={openedSlidingPane?.schema}
          id={openedSlidingPane?.row?.id}
          onSubmit={(value) => {
            const tempValue = currentState.value ? [...currentState.value] : [];

            const newValue = tempValue.map((item: any) => {
              return item?.id === value?.id ? value : item;
            });
            setOpenedSlidingPane({});
            setCurrentState({
              value: newValue,
              send: false,
            });

            if (refreshMainTableData) {
              refreshMainTableData();
            }
          }}
          propertiesFromTable={
            openedSlidingPane?.row ? openedSlidingPane?.row : {}
          }
          onClose={(value) => {
            setOpenedSlidingPane({});
          }}
        />
      )}

      {addingEntity && (
        <SlidingPaneAddNew
          schema={guideReservation()}
          mainSchema={guideReservation()}
          id={'new'}
          hasSlidingPane={false}
          onSubmit={(value: any) => {
            if (value) {
              const tempValue = currentState.value
                ? [...currentState.value]
                : [];
              tempValue.push(value);
              setCurrentState({
                value: tempValue,
                send: true,
              });
              setAddingEntity(false);
            }
          }}
          propertiesFromTable={allValue}
          row={{}}
          onClose={(value) => {
            setAddingEntity(false);
          }}
        />
      )}
    </>
  );
};

SPCustomSetFieldForGuideReservation.tableAdapter = <
  T extends NamedEntity = NamedEntity
>(
  schema: SchemaWithClient<T>,
  moreOptions?: boolean
) => {
  const Field: FieldComponent<T[], T[]> = ({
    onChange,
    isActive: active,
    defaultValue,
    forcedValue,
    disabled,
    isMissing,
    mainSchema,
    column,
    accordingToValue,
    allValue,
    refreshMainTableData,
  }) => (
    <SPCustomSetFieldForGuideReservation
      onChange={onChange}
      defaultValue={defaultValue}
      forcedValue={forcedValue}
      disabled={!!disabled}
      isMissing={!!isMissing}
      schema={schema}
      mainSchema={mainSchema}
      column={column}
      accordingToValue={accordingToValue}
      allValue={allValue}
      moreOptions={moreOptions}
      refreshMainTableData={refreshMainTableData}
    />
  );

  Field.includes = () => false;
  Field.comparator = () => 0;

  Field.FilterRenderer = (props) => {
    return (
      <>
        <Field {...props} isActive />
      </>
    );
  };

  return Field;
};
